export default [
  {
    title: "Formularios",
    icon: "FileTextIcon",
    route: "evaluations-list",
    action: "read",
    resource: "evaluations",
  },
];
